import { useMemo } from 'react';

import { extractCoreLabels } from 'src/apps/dashboard/helpers/ConfigurationProcessingHelpers';
import {
	DEFAULT_ENVIRONMENT_DISPLAY_NAME,
	DEFAULT_UNIT_ID_DISPLAY_NAME,
	ENVIRONMENT_LABEL_KEY,
	UNIT_ID_LABEL_KEY
} from 'src/common/consts/platformConfigConsts';
import { getConfiguredValuesFromCoreLabel } from 'src/common/helpers/ConfigurationWarningsHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const useWfaConfiguredValues = (): {
	environment: Set<string>;
	unitId: Set<string>;
	environmentDisplayName: string;
	unitIdDisplayName: string;
} => {
	const { configuration } = useConfiguration();

	return useMemo(() => {
		if (!configuration?.PLATFORM) {
			return {
				environment: new Set<string>(),
				unitId: new Set<string>(),
				environmentDisplayName: DEFAULT_ENVIRONMENT_DISPLAY_NAME,
				unitIdDisplayName: DEFAULT_UNIT_ID_DISPLAY_NAME
			};
		}

		const coreLabels = extractCoreLabels(configuration.PLATFORM);
		const environmentLabel = coreLabels.find((label) => label.label === ENVIRONMENT_LABEL_KEY);
		const unitIdLabel = coreLabels.find((label) => label.label === UNIT_ID_LABEL_KEY);

		return {
			environment: getConfiguredValuesFromCoreLabel(environmentLabel),
			unitId: getConfiguredValuesFromCoreLabel(unitIdLabel),
			environmentDisplayName: environmentLabel?.displayName || DEFAULT_ENVIRONMENT_DISPLAY_NAME,
			unitIdDisplayName: unitIdLabel?.displayName || DEFAULT_UNIT_ID_DISPLAY_NAME
		};
	}, [configuration]);
};
